import truncationDont from "../../../../src/pages/foundations/content/language-and-grammar/_assets/truncation-do.png";
import truncationDo from "../../../../src/pages/foundations/content/language-and-grammar/_assets/truncation-dont.png";
import Link from '@atlaskit/link';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import * as React from 'react';
export default {
  truncationDont,
  truncationDo,
  Link,
  SectionMessage,
  SectionMessageAction,
  React
};